/** @module Sourcing/MassDeleteSupplierItems */
define([
	"dojo/_base/declare",
	"underscore",
	"./MassActionSupplierItems"
], function(declare,_,MassActionSupplierItems) {

	return declare(MassActionSupplierItems, {
		toWriter: function() {
			var urls = _.pluck(this.m_formData.getSelectedNodes(), "$URL");
			var w = this.m_writer;
			// batch size is set in C8-17094
			w.deleteList(urls, 1);
			w.addParameter("FaultTolerant", "true");

			return w;
		}
	});
});
